import { submitInvoice } from './invoice-submission.js';

/**
 * A billing item gone (404) or changed (409) since the dialog opened. A 404 can also be the client itself,
 * which the plain-text answer does not tell apart; either way the dialog shows outdated data.
 */
const STALE = Object.freeze({
  isStale: (error) => error.status === 404 || error.status === 409,
  message: 'This client changed in the meantime. Close and open the invoice again.',
});

/**
 * Connects the client invoice dialog to the API. The To invoice tab opens it by dispatching
 * `billing-client-invoice-request` with `{group}`; a recorded invoice dispatches `billing-changed` on
 * `document`, and so does a rejection because the client changed meanwhile, so the To invoice tab reloads.
 */
export class ClientInvoiceEventAdapter {
  #apiAdapter;
  #dialogComponent;
  #notificationComponent;
  #reloadPage;

  /**
   * @param {() => void} [reloadPage] reloads the app so index.js shows the login screen
   */
  constructor(apiAdapter, dialogComponent, notificationComponent, reloadPage = location.reload.bind(location)) {
    this.#apiAdapter = apiAdapter;
    this.#dialogComponent = dialogComponent;
    this.#notificationComponent = notificationComponent;
    this.#reloadPage = reloadPage;
  }

  connect() {
    document.addEventListener('billing-client-invoice-request', this.#onRequest);
    document.addEventListener('billing-client-invoice-submit', this.#onSubmit);
  }

  disconnect() {
    document.removeEventListener('billing-client-invoice-request', this.#onRequest);
    document.removeEventListener('billing-client-invoice-submit', this.#onSubmit);
  }

  #onRequest = (event) => {
    this.#dialogComponent.open(event.detail.group);
  };

  #onSubmit = (event) => {
    const { slug, request } = event.detail;
    return submitInvoice(this.#dialogComponent, this.#notificationComponent, this.#reloadPage,
      () => this.#apiAdapter.invoiceClient(slug, request), STALE);
  };
}
